import { paths } from '@constants/paths';
import { ProductSubtype } from '@generated/gql/graphql';

export interface InsuranceAvailability {
  boilerAvailable: boolean;
  incomeAvailable: boolean;
}

const getInsuranceProductSubtype = ({
  boilerAvailable,
  incomeAvailable,
}: InsuranceAvailability): ProductSubtype | undefined => {
  const hasBhcOnly = boilerAvailable && !incomeAvailable;
  const hasIpOnly = incomeAvailable && !boilerAvailable;

  if (hasBhcOnly) {
    return ProductSubtype.BoilerHomeCover;
  }

  if (hasIpOnly) {
    return ProductSubtype.IncomeProtector;
  }

  return undefined;
};

const getInsuranceNavigationPaths = ({
  boilerAvailable,
  incomeAvailable,
}: InsuranceAvailability) => {
  const bothAvailable = boilerAvailable && incomeAvailable;
  const navigationPath = bothAvailable ? paths.insurance : paths.bundle;

  return {
    backPath: navigationPath,
    selectPath: navigationPath,
    deselectPath: navigationPath,
  };
};

const getInsuranceRedirectPath = ({
  boilerAvailable,
  incomeAvailable,
}: InsuranceAvailability): string | null => {
  if (boilerAvailable && !incomeAvailable) {
    return paths.bhc;
  }

  if (!boilerAvailable && incomeAvailable) {
    return paths.ip;
  }

  return null;
};

export {
  getInsuranceProductSubtype,
  getInsuranceNavigationPaths,
  getInsuranceRedirectPath,
};
